"use client";

import { Image } from "@heroui/image";
import { motion } from "framer-motion";
import React from "react";

import { About1 } from "@/public/assets";

const AboutBanner = () => {
  return (
    <section className="lg:px-28 px-6 max-w-screen-2xl mx-auto pt-12 lg:pt-[66px]">
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
        whileInView={{ opacity: 1, scale: 1 }}
      >
        <Image
          removeWrapper
          alt="about image"
          className="
            h-[260px]
            sm:h-[340px]
            lg:h-[448px]
            object-cover
            w-full
            rounded-[24px]
            mb-12
            lg:mb-[66px]
          "
          src={About1.src}
        />
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-0 items-start lg:items-center justify-between pb-16 lg:pb-[66px]">
        <motion.div
          className="
            text-[32px]
            sm:text-[36px]
            lg:text-[40px]
            font-medium
            leading-[40px]
            sm:leading-[44px]
            lg:leading-[48px]
            tracking-[-0.4px]
            max-w-md
          "
          initial={{ opacity: 0, y: 32 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.4 }}
          whileInView={{ opacity: 1, y: 0 }}
        >
          Finding the right people without the guesswork
        </motion.div>

        <motion.div
          className="
            text-neutral-500
            text-base
            font-normal
            leading-6
            tracking-[-0.176px]
            max-w-xl
          "
          initial={{ opacity: 0, y: 32 }}
          transition={{ duration: 0.7, delay: 0.15, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.4 }}
          whileInView={{ opacity: 1, y: 0 }}
        >
          At Cotton Recruiting, we help businesses make better hiring decisions
          — with clarity, structure, and a process that works.
        </motion.div>
      </div>
    </section>
  );
};

export default AboutBanner;
